// extracted by mini-css-extract-plugin
export default {"search":"Search-module--search--eab94"};